import {
  PcmBindingTypeModel,
  PcmCommitmentTypeModel,
  PcmProductCategory,
} from '@app/sales/modules/subscription/models/pcm-product.model';
import { Price, PriceInformationPaymentType } from './price.model';
import { SubscriptionOffering } from './subscription-offering.model';

export class AssignedSubscriptionOffering {
  subscriptionId: number;
  subscriptionOffering: SubscriptionOffering;
}

export class AssignedSubscriptionModel {
  subscriptionNo: number;
  customerNumber: string;
  displayName?: string;
  monthlyCost?: Price;
  msisdn: string;
  mobilePlan: AssignedMobilePlanProductModel;
  discountProducts: AssignedDiscountProductModel[];
  bindings: AssignedBindingProductModel[];
  topups: AssignedTopUpProductModel[];
  addons: AssignedServiceProductModel[];
  isEquipmentUpgradeCompatible: boolean;
  allLabels: string[];
  mainSim?: SimProductModel;
}

export class AssignedMobilePlanProductModel {
  dataVolumeInMb: number;
  numberCategory: string;
  productClassification: string;
  subscriptionType: SubscriptionType;
  productNo: string;
  productDetails: AssignedProductDetailsModel;
  startDate: Date;
  endDate: Date | null;
  priceSummary: AssignedPriceSummaryModel;
  costs: AssignedCostModel[];
  discounts: AssignedDiscountModel[];
}

export class AssignedProductDetailsModel {
  productId: string;
  productNo: string;
  pcmProductCategory: PcmProductCategory;
  name: string;
  description: string;
  labels: string[];
  upperAgeLimit: number | null;
  lowerAgeLimit: number | null;
  isEquipmentUpgradeCompatible: boolean;
  isActive: boolean;
  currentState: AssignedProductState;
}

export class AssignedPriceSummaryModel {
  paymentType: PriceInformationPaymentType;
  price: Price;
  isDiscounted: boolean;
  discountName: string;
  discountLength: number | null;
  discountStartDate: Date | null;
  discountEndDate: Date | null;
  discountAmount: Price;
  originalPrice: Price;
}

export class AssignedCostModel {
  description: string;
  price: Price;
  originalPrice: Price;
  billingPeriodUnit: string;
  startDate: Date | null;
  endDate: Date | null;
  activeCustomerLevelDiscounts: string[];
}

export class AssignedDiscountModel {
  description: string;
  amount: Price;
  billingPeriodUnit: string;
  startDate: Date | null;
  endDate: Date | null;
}

export class AssignedDiscountProductModel {
  productDetails: AssignedProductDetailsModel;
  discounts: ReadonlyArray<AssignedDiscountModel>;
}

export class AssignedBindingProductModel {
  productDetails: AssignedProductDetailsModel;
  startDate: ProductDate;
  expirationDate: ProductDate;
  commitmentType: string;
  pcmCommitmentType: PcmCommitmentTypeModel;
  bindingType: PcmBindingTypeModel;
  bindingPeriodInMonths: number;
  penaltyType: string;
  initialTerminationFee: Price;
  remainingTerminationFee: Price;
}

export interface ProductDate {
  year: number;
  month: number;
  day: number;
}

export class AssignedServiceProductModel {
  serviceType: string;
  subscriptionServiceType: SubscriptionServiceType;
  subscriptionServiceCategoryTypes: string[];
  productNo: string;
  productDetails: AssignedProductDetailsModel;
  startDate: Date;
  endDate: Date | null;
  priceSummary: AssignedPriceSummaryModel;
  costs: AssignedCostModel[];
  discounts: AssignedDiscountModel[];
}

export class AssignedTopUpProductModel extends AssignedServiceProductModel {
  dataVolumeInMb: number;
  isRestOfTheWorldTopup: boolean;
}

export enum AssignedProductState {
  Unknown,
  Active,
  Assigning,
  Updating,
  Terminating,
  Barred,
  Terminated,
  ActiveUntilEndDate,
}

export enum SubscriptionType {
  Regular = 0,
  Trial = 2,
  IceJunior = 3,
  IceTeen = 4,
  IceYoung = 5,
  BTL = 6,
  MbbWeekly = 7,
  Flex = 9,
  IcePlus = 10,
  PayAsYouGo = 12,
  Unlimited = 13,
  SeparateEuWithoutRolloverInEu = 14,
  Unknown = 99,
}

export enum SubscriptionServiceType {
  Unknown,
  TopUp,
  TopUpRoW,
  DataFrihet,
  Netflix,
}

export class SimProductModel {
  isEsim: boolean;
}
